import type { ComponentProps, PropsWithChildren } from 'react';
import type React from 'react';

import { Box, Container } from '@change-corgi/design-system-legacy/layout';

type Props = Readonly<{
	big?: boolean;
	/**
	 * default: error (yellow)
	 */
	variant?: 'error' | 'success' | 'purple';
}>;

export const BannerWrapper: React.FC<PropsWithChildren<Props> & Omit<ComponentProps<typeof Box>, 'variant'>> = ({
	children,
	big,
	variant,
	...rest
}) => {
	const FlashMessage = variant === 'success' ? FlashMessageSuccess : FlashMessageError;

	return (
		<FlashMessage
			role="alert"
			sx={
				variant === 'purple'
					? {
							backgroundColor: '#3E1B63',
							color: 'primary-white',
						}
					: {
							borderBottomWidth: 1,
							borderBottomStyle: 'solid',
						}
			}
			data-nosnippet
			{...rest}
		>
			<Container
				variant="small"
				px={8}
				sx={{
					lineHeight: big ? '24px' : '20px',
					fontSize: big ? 16 : 14,
					'& a': {
						textDecoration: 'underline',
						fontWeight: 'bold',
						color: 'inherit',
						'&:hover': {
							color: 'inherit',
						},
					},
				}}
				py={big ? 8 : 2}
			>
				{children}
			</Container>
		</FlashMessage>
	);
};

const FlashMessageError: React.FC<PropsWithChildren<EmptyIntersection> & ComponentProps<typeof Box>> = ({
	children,
	...rest
}) => {
	return (
		<Box
			sx={{
				// TODO change default colors
				color: '#b48629',
				background: '#fff9df',
				borderBottomStyle: 'solid',
				borderBottomWidth: 1,
				borderBottomColor: '#ffe9aa',
				a: {
					color: '#b48629',
					textDecoration: 'underline',

					'&:hover, &:focus': {
						color: '#dab65d',
					},
				},
			}}
			{...rest}
		>
			{children}
		</Box>
	);
};

const FlashMessageSuccess: React.FC<PropsWithChildren<EmptyIntersection> & ComponentProps<typeof Box>> = ({
	children,
	...rest
}) => {
	return (
		<Box
			sx={{
				// TODO change default colors
				color: '#497143',
				background: '#e2eee0',
				borderBottomColor: '#bbd6b2',
				a: {
					color: '#63985a',
					textDecoration: 'underline',

					'&:hover, &:focus': {
						color: '#63985a',
					},
				},
			}}
			{...rest}
		>
			{children}
		</Box>
	);
};
